import * as CONST from "./actionTypes";

export const getCrypto = (payload) => ({
  type: CONST.GET_CRYPTO,
  payload: payload,
});

export const getCryptoSuccess = (data) => ({
  type: CONST.GET_CRYPTO_SUCCESS,
  payload: data,
});

export const getCryptoFail = (error) => ({
  type: CONST.GET_CRYPTO_FAIL,
  payload: error,
});




